import React from 'react';

interface SelectProps {
  label: string;
  name: string;
  value: string;
  options: any[];
  placeholder?: string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  className?: string;
  selectClassName?: string;
}

const Select: React.FC<SelectProps> = ({
  label,
  name,
  value,
  options,
  placeholder = 'Select option',
  onChange,
  className = '',
  selectClassName = '',
}) => {
  return (
    <div className={`select-group ${className}`}>
      <label
        htmlFor={name}
        className="block mb-2 text-grey text-[16px] manrope capitalize"
      >
        {label}
      </label>
      <select
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        className={`px-6 p-4 mb-3 text-[16px] bg-white w-full border-[1px] duration-300 border-[#d3d3d3] focus:border-orange rounded-md ${selectClassName}`}
      >
        <option value="" disabled>
          {placeholder}
        </option>
        {/* {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))} */}
        {options.map((state) => (
          <option key={state} value={state}>
            {state}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Select;
